import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FacilitySummaryObject } from '../../../../core/services/facility.model';
import { FacilityService } from '../../../../core/services/facility.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MultiFacilityService } from '../../../services/multi-facility.service';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { MultiFacilityModel } from 'src/app/post-login/services/multi-facility.model';
import { CommonUtil } from '../../../../core/Utils/common-util';
import { HaloToastService, EToastType } from 'src/app/core/halo-toast/halo-toast.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss'],
})
export class TreeComponent implements OnInit {
  @Input() treeData: MultiFacilityModel;
  @Input() isMobile: boolean;
  @Input() isRTL: boolean;
  @Input() facilities: MultiFacilityModel[];
  showSetLevelModal: boolean = false;
  selectedTreeFacility: FacilitySummaryObject;
  rootScopeData: RootScopeDeclare;
  sole_manager: boolean;
  showModal: boolean = false;
  delinkFacilityId: string;
  delinkChildFacilityId:string[] = [];
  delinkModalTitle: any;
  delinkModalMessage: any;
  cannotDelinkModalMessage: any;
  updatedFacilities: any;
  showDelink: boolean = true;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _facilityService: FacilityService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private multiFacService: MultiFacilityService,
    private rootScopeService: RootScopeService,
    private commonUtil: CommonUtil,
    private _toast: HaloToastService,
    private loader: HaloLoaderService
  ) {}

  ngOnInit(): void {
    this.getRootScopeData();
    this.sole_manager = false;
    this.showDelinkOption();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
  }

  toggleChild(node: any) {
    node.showChildren = !node.showChildren;
  }

  identify(index: Number, item: MultiFacilityModel) {
    return item.facilityId;
  }

  editFacility(facId: string): void {
    this._facilityService.selectFacility(facId, true);
    this._router.navigate(['edit'], { relativeTo: this._route });
  }

  setLevel(index: Number, fac: FacilitySummaryObject): void {
    this.selectedTreeFacility = fac;
    this.showSetLevelModal = true;
  }

  closeSetLevelModal($event: boolean): void {
    this.showSetLevelModal = false;
  }

  delinkFacility(facId: string, facName: string, selectedFacility: any): void {
    this.delinkFacilityId = '';
    this.delinkChildFacilityId = [];
    this.delinkFacilityId = facId;
    this.openModal();
    selectedFacility.children.forEach((lvlOne:any) => {
      this.delinkChildFacilityId.push(lvlOne.facilityId);
      lvlOne.children.forEach((lvlTwo:any) => {
        this.delinkChildFacilityId.push(lvlTwo.facilityId);
        lvlTwo.children.forEach((lvlThree:any) => {
          this.delinkChildFacilityId.push(lvlThree.facilityId);
          lvlThree.children.forEach((lvlFour:any) => {
            this.delinkChildFacilityId.push(lvlFour.facilityId);
          });
          
        });
        
      });
    });
    this.delinkModalTitle = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELINK.FACILITY.MODAL.TITLE', [
      facName,
    ]);
    this.delinkModalMessage = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELINK.FACILITY.MODAL.MESSAGE', [
      facName,
    ]);
    this.cannotDelinkModalMessage = this.commonUtil.replaceValueAsHTMLOnTranslatedText('CANNOT.DELINK.MESSAGE', [
      facName,
      facName,
    ]);
    let facility = this._facilityService.allFacilities().get(facId);
    if (selectedFacility?.soleManager == 'true' && facility?.isLoggedInManagerAdmin == 'true') {
      this.sole_manager = true;
    } else {
      this.sole_manager = false;
    }
  }

  openModal(): void {
    this.showModal = true;
  }

  onPositiveConfirmation(): void {
    this.closeModal();
    this.loader.startProcess();    
    this._amplitudeAnalytics.logEvent({elementName: 'Delink User', action: 'Submit'});
    this.multiFacService.deLinkUser(this.delinkFacilityId).subscribe(
      (data) => {
        this.multiFacService.invitedFacilities(); // refresh counts
        this.loader.endProcess();
        this._toast.creatToast(
          this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELINK.SUCCESS.MESSAGE', [this.treeData.facilityName]),
          EToastType.SUCCESS
        );

        //reset facility dropdown after delinked.
        let obj = {facilityId:this.delinkFacilityId,childFacilityId:this.delinkChildFacilityId};
        this._facilityService.updateDelinkFacility(obj);
      },
      (error) => {
        this.loader.endProcess();
      }
    );
  }

  goToStaff() {
    this._facilityService.selectFacility(this.delinkFacilityId, true);
    this._router.navigate(['/facility/staff']);
  }

  closeModal(): void {
    this.showModal = false;
  }

  showDelinkOption() {
    if (this.facilities) {
      this.showDelink = this.facilities.length > 1;
    }
  }
}
